import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { claimFileCategoryApi } from '@/main/api';
import { saveClaimFileCategory } from './index';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

// Api's

export function* getClaimFileCategorySaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      claimFileCategoryApi.getDomain
    );

    if (response.data.result) {
      yield put(saveClaimFileCategory(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveClaimFileCategory(null, true, resultError.messagesDataError));
    }
  }
}
